var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEditor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M240 90v140c0 11.046-8.954 20-20 20H60c-11.046 0-20-8.954-20-20V90zm-90 90H90c-5.523 0-10 4.477-10 10v10c0 5.523 4.477 10 10 10h60c5.523 0 10-4.477 10-10v-10c0-5.523-4.477-10-10-10m40-50H90c-5.43 0-9.848 4.327-9.996 9.72L80 140v10c0 5.43 4.327 9.848 9.72 9.996L90 160h100c5.43 0 9.848-4.327 9.996-9.72L200 150v-10c0-5.523-4.477-10-10-10m30-100c11.046 0 20 8.954 20 20v20H40V50c0-11.046 8.954-20 20-20z"
})));
export default SvgEditor;